import { Box, Divider, Grid, Typography, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";
import { useState, useEffect } from "react";
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import Cancel from '@mui/icons-material/CancelOutlined';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const AddHsnList = ({ handlecallback, editStoreID, editData }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [hsncode, setHsncode] = useState('');
    const [effectivefromdate, setEffectivefromdate] = useState('');
    const [cgstpercent, setCgstpercent] = useState('');
    const [sgstpercent, setSgstpercent] = useState('');
    const [igstpercent, setIgstpercent] = useState('');
    const [cesspercent, setCesspercent] = useState('');
    const [acesspercent, setAcesspercent] = useState('');

    useEffect(() => {
        if (editData) {
            setHsncode(editData.hsncode || '');
            setEffectivefromdate(editData.effectivefromdate || '');
            setCgstpercent(editData.cgstpercent || '');
            setSgstpercent(editData.sgstpercent || '');
            setIgstpercent(editData.igstpercent || '');
            setCesspercent(editData.cesspercent || '');
            setAcesspercent(editData.acesspercent || '');
        } else {
            setHsncode('');
            setEffectivefromdate('');
            setCgstpercent('');
            setSgstpercent('');
            setIgstpercent('');
            setCesspercent('');
            setAcesspercent('');
        }
    }, [editData]);

    const handleSave = async () => {
        try {
            let company_id = localStorage.getItem('companyid') || 1;

            const para = {
                p_companyid: company_id,
                p_id_hsn: editStoreID === 0 ? 0 : editStoreID,
                hsncode: parseInt(hsncode || 0),
                effectivefromdate: effectivefromdate,
                cgstpercent: parseFloat(cgstpercent || 0),
                sgstpercent: parseFloat(sgstpercent || 0),
                igstpercent: parseFloat(igstpercent || 0),
                cesspercent: parseFloat(cesspercent || 0),
                acesspercent: parseFloat(acesspercent || 0),
                mode: editStoreID === 0 ? 0 : 1,
            };

            const result = await callApi(API_ENDPOINTS.SALES_HSN_SAVE, 'POST', { 'Content-Type': 'application/json' }, para);

            if (result && result.length > 0) {
                alert(editStoreID === 0 ? "HSN Added Successfully" : "HSN Updated Successfully");
                handlecallback();
            } else {
                alert("Unexpected API response.");
            }
        } catch (error) {
            alert(error.message || "Something went wrong");
        }
    };

    const handleCancel = () => {
        handlecallback();
    };

    return (
        <Box padding={0}>
            <Header title={editStoreID === 0 ? 'Add HSN Entry' : 'Edit HSN Entry'} subtitle="" callback={handlecallback} />
            <Divider />

            <Box sx={{
                padding: "5px",
                borderRadius: "10px",
                maxHeight: '74vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': { width: '8px' },
                '&::-webkit-scrollbar-track': { background: colors.primary[400], borderRadius: '10px' },
                '&::-webkit-scrollbar-thumb': { background: colors.blueAccent[600], borderRadius: '10px' },
                '&::-webkit-scrollbar-corner': { background: colors.primary[700] }
            }}>

                <Grid container spacing={2} padding="20px">

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>HSN Code</Typography>
                        <TextField
                            value={hsncode}
                            onChange={(e) => setHsncode(e.target.value)}
                            fullWidth
                            size="small"
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <SettingsIcon style={{ fontSize: "20px" }} />
                                    </InputAdornment>
                                ),
                                readOnly: editStoreID !== 0 ? true : false,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>Effective Date</Typography>
                        <TextField type="date" value={effectivefromdate} onChange={(e) => setEffectivefromdate(e.target.value)} fullWidth size="small" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>CGST %</Typography>
                        <TextField type="number" value={cgstpercent} onChange={(e) => setCgstpercent(e.target.value)} fullWidth size="small" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>SGST %</Typography>
                        <TextField type="number" value={sgstpercent} onChange={(e) => setSgstpercent(e.target.value)} fullWidth size="small" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>IGST %</Typography>
                        <TextField type="number" value={igstpercent} onChange={(e) => setIgstpercent(e.target.value)} fullWidth size="small" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>Cess %</Typography>
                        <TextField type="number" value={cesspercent} onChange={(e) => setCesspercent(e.target.value)} fullWidth size="small" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" fontSize={14}>ACess %</Typography>
                        <TextField type="number" value={acesspercent} onChange={(e) => setAcesspercent(e.target.value)} fullWidth size="small" />
                    </Grid>

                </Grid>

               <Grid container>
               
                       <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                         <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                           <Toolbar>
                             <Button size="small" variant="contained" color="secondary" onClick={handleSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save HSN</Button>
                             <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                           </Toolbar>
                         </Box>
                       </Grid>
                     </Grid>

            </Box>
        </Box>
    );
};

export default AddHsnList;
